var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('HeaderOfPage',{attrs:{"bgSrc":'banner-4.jpeg',"titleOfPage":'الفنادق',"theDiscription":'ديسكربشن'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }